var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-switch",class:{ notSure: !_vm.value },on:{"click":_vm.handlerToggleSwitch}},[_c('span',{class:{ 'is-on': +_vm.value === +_vm.on }})])
}
var staticRenderFns = []

export { render, staticRenderFns }